const resource = {
  "main": {
    "slogan": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["AI翻訳で韓国と日本をもっと近く。"])},
    "tagline": {
      "line1": {
        "before": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["韓国と日本を、"])},
        "highlight": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["もっと近く"])},
        "middle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["。"])},
        "highlight2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "after": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
      },
      "line2": {
        "before": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "highlight": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["AI"])},
        "middle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["が最初の挨拶から返信までサポート。"])},
        "highlight2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "after": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
      },
      "line3": {
        "before": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "highlight": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "middle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "highlight2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "after": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
      },
      "desc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["言葉の壁を気にせず、韓国人の友達・恋人・言語交換相手と出会えます。\nAI翻訳とメッセージ提案、厳選おすすめで自然な会話を始めましょう。"])}
    }
  },
  "home": {
    "mealManagement": {
      "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["AI翻訳で\n言葉の壁をゼロへ"])},
      "desc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["韓国語でも日本語でも、MoTobiが自然な会話になるよう翻訳します。\n\n- 双方向のリアルタイム翻訳\n- AIが自然な表現に補正\n- 原文と翻訳文を一緒に確認\n\n言葉で止まらず、会話を続けられます。"])},
      "button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["詳しく見る"])},
      "imageAlt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["AI翻訳チャット画面"])}
    },
    "mealInput": {
      "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["最初の挨拶も返信も\nAIが提案"])},
      "desc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["何を送ればいいか迷った時、プロフィールや会話の流れに合うメッセージを提案します。\n\n- 興味に合わせた初回メッセージ\n- 雰囲気に合う返信候補\n- 韓国語と日本語の表現を同時に調整\n\n翻訳だけでなく、自然な始まりまで支えます。"])},
      "button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["詳しく見る"])},
      "imageAlt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["AIメッセージ提案画面"])}
    },
    "about": {
      "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["1日3〜5人だけ\n丁寧におすすめ"])},
      "desc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["無制限スワイプではなく、興味・言語レベル・目的に合う相手を厳選します。\n\n- 友達・恋愛・言語交換の目的を反映\n- 韓国/日本文化への興味でマッチ\n- 疲れにくい少数精鋭のおすすめ\n\nたくさん見るより、ちゃんと出会う体験を目指します。"])},
      "button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["詳しく見る"])},
      "cta": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["今日のおすすめを見る"])}
    },
    "nutrition": {
      "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["本人確認で\n安心できる出会いへ"])},
      "desc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["国を越えた出会いだからこそ、信頼できるプロフィール表示を大切にします。\n\n- ID確認済みバッジ\n- スパムや放置アカウント対策\n- 通報・ブロック導線\n\n初めての相手とも安心して話せる環境を作ります。"])},
      "button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["詳しく見る"])},
      "cta": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["認証プロフィールを見る"])}
    },
    "weight": {
      "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["韓国カルチャーから\n自然に話せる"])},
      "desc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kドラマ、旅行、音楽、グルメ、語学学習など、会話が始まりやすい興味でつながります。\n\n- 文化・趣味タグ\n- 言語交換レベル表示\n- 会話トピック提案\n\n自然に気になる相手と出会えます。"])},
      "button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["詳しく見る"])},
      "cta": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["興味で探す"])}
    },
    "aboutPro": {
      "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["友達から恋人まで\n目的に合わせて"])},
      "desc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["言語交換、現地の友達、真剣な出会いまで、求める関係性をわかりやすく表示します。\n\n- 出会いの目的を選択\n- 会話ペースと言語レベルを反映\n- チャット前に信頼情報を確認\n\n期待が合う相手と始められます。"])},
      "button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["詳しく見る"])},
      "cta": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["プロフィールを見る"])}
    },
    "formulas": {
      "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["MoTobiが日韓の距離をもっと近く"])},
      "desc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["AI翻訳、メッセージ提案、厳選おすすめ、本人確認をひとつのアプリに。\n\n- 韓国語/日本語の会話サポート\n- 初回メッセージと返信提案\n- 1日3〜5人の厳選おすすめ\n\n言葉の不安を減らし、出会いの質を高めます。"])},
      "button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["詳しく見る"])},
      "cta": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["MoTobiを始める"])}
    },
    "statistics": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["日韓マッチングのための設計"])},
      "cards": {
        "app": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["App Store"])},
          "rating": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["リリース準備中"])},
          "reviews": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["MoTobi事前登録予定"])}
        },
        "play": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Google Play"])},
          "rating": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["リリース準備中"])},
          "reviews": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["MoTobi事前登録予定"])}
        },
        "global": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["サービス方針"])},
          "users": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["1日3〜5人の厳選おすすめ"])},
          "hours": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["AIリアルタイム翻訳"])},
          "workouts": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["本人確認ベースの安全設計"])}
        },
        "effect": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["提供価値"])},
          "rate": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["言語の壁を小さく"])},
          "retention": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["韓国/日本カルチャーでつながる"])},
          "drop": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["スパム・放置アカウント削減を目標"])}
        }
      },
      "foot": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["MoTobiは韓国と日本をもっと近くするAIマッチングサービスです。"])},
      "note": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["* リリース前のコンセプト文言です。実際の運用データ取得後に更新してください。"])}
    }
  },
  "navigation": {
    "navbar": {
      "appTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["MoTobi"])},
      "languages": {
        "en": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["英語"])},
        "kr": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["韓国語"])},
        "jp": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["日本語"])}
      },
      "subpages": {
        "learnMore": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["詳しく見る"])},
        "appStore": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["App Store"])},
        "googlePlay": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Google Play"])},
        "formulas": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Formulas"])},
        "books": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Books"])},
        "articles": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Articles"])},
        "statistics": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Statistics"])},
        "info": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Informations"])},
        "donate": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Donate"])}
      }
    },
    "footer": {
      "privacyPolicy": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["プライバシーポリシー"])},
      "termsOfUse": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["利用規約"])},
      "cookiePolicy": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cookieポリシー"])},
      "copyrights": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["All photos and logos used are copyright-free and made available under the MIT or CC license. It is allowed to use, copy, modify or distribute the original or modified content on this website without restriction, provided that the authorship is acknowledged and the source information is posted."])}
    }
  },
  "sciences": {
    "groups": {
      "all": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["All"])},
      "natural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Natural"])},
      "social": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Social"])},
      "humanities": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Humanities"])},
      "technical": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Technical"])},
      "artistic": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Artistic"])},
      "others": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Others"])}
    },
    "sciences": {
      "philology_iberian": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Iberian Philology"])},
      "philology_english": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["English Philology"])},
      "philology_france": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["French and Benelux Philology"])},
      "philology_italian": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Italian Philology"])},
      "philology_german": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["German Philology"])},
      "philology_poland": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Polish, Ukrainian and Lithuanian Philology"])},
      "philology_baltic": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Baltic Philology"])},
      "philology_nordic": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nordic Philology"])},
      "philology_russian": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Russian Philology"])},
      "philology_carpathian": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Carpathian Philology"])},
      "philology_romanian": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Romanian nad Bulgarian Philology"])},
      "philology_balkan": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["West-Balkan Philology"])},
      "philology_greek": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Greek Philology"])},
      "philology_turkish": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Turkish Philology"])},
      "philology_middleeast": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Middle East, Arabic and Persian Philology"])},
      "philology_indian": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Indian Philology"])},
      "philology_chinese": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chinese Philology"])},
      "philology_korean": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Korean Philology"])},
      "philology_japanese": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Japanese Philology"])},
      "anthropology": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Anthropology"])},
      "philosophy": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Philosophy"])},
      "history": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["History"])},
      "historyofart": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["History of Art"])},
      "culturalstudies": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cultural Studies"])},
      "politology": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Politology"])},
      "law": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Law"])},
      "psychology": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Psychology"])},
      "theology": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Theology"])},
      "defensestudies": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Defense Studies"])},
      "sociology": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sociology"])},
      "internationalstudies": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["International Studies"])},
      "economics": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Economics"])},
      "finances": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Finances"])},
      "accountancy": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Accountancy"])},
      "econometrics": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Econometrics"])},
      "governance": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Governance"])},
      "management": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Management"])},
      "astronomy": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Astronomy"])},
      "bioinformatics": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bioinformatics"])},
      "biochemistry": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Biochemistry"])},
      "biophysics": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Biophysics"])},
      "biotechnology": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Biotechnology"])},
      "biology": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Biology"])},
      "chemistry": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chemistry"])},
      "physics": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Physics"])},
      "geography": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Geography"])},
      "geology": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Geology"])},
      "informatics": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Informatics"])},
      "math": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mathematics"])},
      "ecology": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ecology"])},
      "architecture": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Architecture"])},
      "robotics": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Robotics"])},
      "building_eng": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Building Engeenering"])},
      "energetics": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Energetics"])},
      "electronics": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Electronics"])},
      "quantum_eng": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Quantum Engeenering"])},
      "cosmonautics": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cosmonautics"])},
      "mechanics": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mechanics"])},
      "mechatronics": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mechatronics"])},
      "transport": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Transport"])}
    },
    "branches": {
      "physics": {
        "kinematics": {
          "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kinematics"])},
          "desc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["We study the motion of bodies, including their acceleration, path and speed"])},
          "subjects": {
            "linear-motion": {
              "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Linear Motion"])},
              "formulas": {
                "velocity-basic": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Average speed"])},
                "velocity-deriv": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Instantaneous speed"])},
                "acceleration-basic": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Average acceleration"])},
                "acceleration-deriv": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Instantaneous acceleration"])},
                "motion-eq-a": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Equations of motion cz. 1"])},
                "motion-eq-b": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Equations of motion cz. 2"])},
                "motion-eq-c": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Equations of motion cz. 3"])},
                "motion-eq-d": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Equations of motion cz. 4"])}
              }
            }
          }
        },
        "dynamics": {
          "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dynamika"])},
          "desc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zajmiemy się opisem sił działających na różne ciała, a także ich skutkami"])}
        },
        "energy": {
          "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Energia"])},
          "desc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Praca moc i energia to wielkości, które pozwolą nam spojrzeć na mechanikę z innej strony, a także będą wstępem do kolejnych działów fizyki."])}
        }
      },
      "electronics": {
        "current": {
          "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Prąd elektryczny"])},
          "desc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zaczynamy od podstaw, czyli czym jest prąd elektryczny"])}
        }
      }
    },
    "units": {
      "velocity": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Prędkość"])},
      "distance": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Droga"])},
      "time": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Czas"])},
      "acceleration": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Przyspieszenie"])}
    }
  },
  "pages": {
    "home": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Strona główna"])},
    "formulas": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tablice"])},
    "articles": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Artykuły"])},
    "books": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Podręczniki"])},
    "statistics": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Statystyki"])},
    "info": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Informacje"])},
    "donate": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wesprzyj"])}
  },
  "formulas": {
    "index": {
      "hero": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wzory i tablice naukowe"])}
    },
    "pick": {
      "science": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wybierz jedną z kategorii"])},
      "branch": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wybierz dziedzinę nauki, która cię interesuje"])}
    }
  },
  "errors": {
    "404": {
      "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nasz system nie znalazł takiej strony :c"])},
      "duck": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Więc łap chociaż na pocieszenie kaczkę"])},
      "yeah": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tak, to ten sławny bląd 404"])},
      "song": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bit, bit i pusta kartka, drukarka wydaje szmery Nie ma mnie, bo to nocnego marka nocna warta Świeci się tarcza zegarka - 4:04 Nic nie psuje atmosfery, dźwięki smarta czy wiertarka"])}
    }
  },
  "info": {
    "sure": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ale czy aby na pewno?"])},
    "sections": {
      "begginings": {
        "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Początki"])}
      },
      "activity": {
        "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Działalność"])}
      },
      "goalsandplans": {
        "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cel i plany"])}
      },
      "software": {
        "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Oprogramowanie"])},
        "langscategories": {
          "front-end": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Front-End"])},
          "back-end": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Back-End"])},
          "mobile": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mobilne"])},
          "databases": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bazy danych"])},
          "others": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Inne"])}
        }
      },
      "sponsors": {
        "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sponsorzy"])}
      },
      "authors": {
        "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autorzy"])}
      },
      "thanks": {
        "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Podziękowania"])}
      },
      "donate": {
        "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wesprzyj"])}
      },
      "join": {
        "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dołącz"])}
      },
      "contact": {
        "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kontakt"])}
      }
    }
  }
}
export default resource